import React from "react";
import Loading from "../PrivacyPolicy/Loading";
import { useUserData } from "../../store/UserData";
import { useTranslation } from "react-i18next";

// خريطة ربط نوع الدفع الإنجليزي بالعربي
const paymentTypeMap = {
  bank_transfer: "تحويل بنكي",
  myfatoorah: "ماى فاتورة",
  jeel: "جيل باى",
  tabby: "تابي",
};

const PaymentList = () => {
  const { profile, loading, error } = useUserData();
  const { t } = useTranslation();
  
  if (loading) return <h2><Loading/></h2>;
  if (error) return <p>{error}</p>;
  if (profile?.payment.length === 0) {
    return <p>{t("profile.no-payment")}</p>;
  }

  return (
    <div>
      <ul>
        {profile?.payment.map((item, index) => (
          
          <li key={index} className="bg-light-gray !p-4 flex items-start gap-4 max-lg:flex-col">
            {item.image && (
              <div className="payment-image">
                <img src={item.image} alt="invoice" className="w-52 h-20 rounded-md object-cover max-lg:w-full"/>
              </div>
            )}
            <div className="flex items-center justify-between w-full">
            
            <p className="ltr:text-left rtl:text-start">
                <span className="text-sm">{t('profile.payment-type')}</span>
              <br />
                <strong className="capitalize text-primary-tw">{item?.payment_type?.replaceAll('_', ' ')}</strong>
            </p>

            <p className="ltr:text-left rtl:text-start">
                <span className="text-sm">{t('profile.payment-date')}</span>
              <br />
                <strong className="capitalize text-primary-tw">{item?.created_at}</strong>
            </p>

            <p className="ltr:text-left rtl:text-start">
                <span className="text-sm">{t('profile.price')}</span>
              <br />
                <strong className="capitalize text-primary-tw">{item?.price}</strong>
            </p>

            <p className="ltr:text-left rtl:text-start">
                <span className="text-sm">{t('profile.status')}</span>
              <br />
                <strong className="capitalize text-primary-tw">
                  {item.payment_status === "pending" ? t('profile.pending') : t('profile.not-pending')}
                </strong>
            </p>

            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PaymentList;
